import { useMemo } from 'react';
import initApollo from '../apollo/initApollo';

export default function useApollo(initialState) {
  const store = useMemo(() => initApollo(initialState), [initialState]);
  return store;
}
